<template>
  <div id="app">
    <div>
      <!-- <div>
            <input type="checkbox" @change="inverse" />
            INVERSE
        </div> -->

      <div v-for="(item, index) of product" :key="index">
        <div class="fruit">
          <div>
            <input
              class="tui-checkbox"
              type="checkbox"
              :value="item.skuId"
              v-model="model"
            />
            <span></span>
          </div>

          <div class="tuipopup">
            <div class="tui-popup-img" @click="detail(item.productId)">
              <img width="100%" :src="item.banners" />
            </div>
            <div class="tuipopup-item">
              <div>
                <div class="label">{{ item.chineseName }}</div>
                <div class="value">{{ item.code }}</div>
                <div style="display: flex; justify-content: space-between">
                  <div class="price">{{ item.integralNum }}积分</div>
                  <div style="display: flex; align-items: center">
                    <div class="cut" @click="cuts(item, index)">-</div>
                    <div class="num">{{ item.amount }}</div>
                    <div class="add" @click="add(item, index)">+</div>
                  </div>
                </div>
              </div>

              <!-- <div @click="" class="delate">删除</div> -->
            </div>
          </div>
        </div>
        <div class="delate">
          <!-- <van-button round color="var(--theme-color-main)" style="width:70px" type="primary" @click="delate(item)">删除
                </van-button> -->
          <div
            style="border: 1px #2283e2 solid"
            class="gopay"
            @click="delate(item)"
          >
            删除
          </div>
        </div>
      </div>
      <div v-if="this.product.length <= 0">
        <notData
          title="暂无相关商品"
          content="每天都给自己一个惊喜，看看其他商品吧"
          :img="notImg"
        ></notData>
      </div>
      <div class="item">
        <div class="tui-flex">
          <input class="tui-checkbox" type="checkbox" v-model="checkAll" />
          <span>全选</span>
        </div>
        <div class="tui-flex">
          <div class="tui-total">
            <span>总价:{{ total }}积分</span>
          </div>
          <div>
            <van-button
              round
              block
              color="var(--theme-color-main)"
              type="primary"
              @click="orderSettlement()"
              >去结算
            </van-button>
          </div>
        </div>
      </div>
    </div>

    <!-- <div>已选择:{{ model }} 总价:{{ total }}</div> -->
  </div>
</template>

<script>
import utils from "@/utils/utils";
import {
  getProductDetails,
  haierDelShoppingCart,
  haierOrderShoppingCart,
  getByRiskRule,
  AndProperty,
} from "../../api/api";
import notData from "@/components/notData.vue";
export default {
  name: "App",
  components: {
    notData,
  },
  data() {
    return {
      notImg: require("../../../static/images/product/not-product.png"),
      // value:,
      fruits: [],
      model: [],
      product: [],
      productId: "",
      amount: "",
      deleteList: {},
      skuId: "",
      num: "",
      code: "",
      banners: "",
      data: [],
    };
  },
  computed: {
    checkAll: {
      get() {
        // return this.model.length === this.product.length;
        return (
          this.model.length === this.product.length && this.model.length != 0
        );
      },
      set(val) {
        if (val) {
          this.model = [];
          this.product.forEach((fruit) => {
            this.model.push(fruit.skuId);
          });
        } else {
          this.model = [];
        }
      },
    },
    total() {
      let t = 0;
      this.model.forEach((item) => {
        let index = this.product.findIndex((fruit) => fruit.skuId === item);
        t += this.product[index].integralNum * this.product[index].amount;
      });
      return t;
    },
  },
  mounted() {
    // this.getByRiskRule();
    this.selHaierShoppingCart();
    console.log(this.product,"-----------");
    // this.getProduct();
  },

  methods: {
    //购物车删除
    delate: function (item) {
      let this_ = this;
      let tt = this.product.filter((it) => it.skuId == item.skuId);
      this_.deleteList.userId =
        this.$cookies.get("memberId") || sessionStorage.getItem("memberId");
      this_.deleteList.productId = tt[0].productId;
      this_.deleteList.skuId = tt[0].skuId;
      this.delateProduct(item);
    },
    async delateProduct(item) {
      let params = this.deleteList;
      let this_ = this;
      const res = await haierDelShoppingCart(params);
      if (res.code === "0000") {
        this.$toast("删除成功");
        //let fruitsOld = this.fruits.filter(it => it.productId != item.id);
        let productOld = this.product.filter((it) => it.skuId != item.skuId); //购物车列表
        if (this.model.length > 0) {
          //选择列表
          let modelOld = this.model.filter((it) => it != item.skuId); //获取不与当前项删除的数据
          this.model = [];
          modelOld.forEach((p) => {
            this.model.push(p);
          });
        }
        //this.fruits = [];
        this.product = [];
        if (productOld.length > 0) {
          productOld.forEach((p) => {
            this.product.push(p);
          });
        }
      }
    },
    //购物车列表
    async selHaierShoppingCart() {
      let params = {
        userId:
          this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
        amount: 0,
      };
      const res = await haierOrderShoppingCart(params);
      if (res.code == "0000") {
        this.commCart(res.data);
      }
    },
    async commCart(data) {
      //
      console.log(data,"------data")
      // let data = [
      //   {
      //     amount: 2,
      //     memberPhone: "18562635382",
      //     code: "",
      //     memberName: "\"H514R1666679975120\"",
      //     clt: "h5",
      //     userId: "2057695335",
      //     banners: "http://haier-jfsc-public.oss-cn-beijing.aliyuncs.com/20230417/f4ec86ddfb89d513519e4dd4763267d0",
      //     skuId: "20850",
      //     thirdProductCode: "44444444444433",
      //     token: "86ab1da107b74306aaff6191ca1de0f2",
      //     memberId: "2057695335"
      //   },
      //   {
      //     amount: 1,
      //     memberPhone: "18562635382",
      //     code: "规格:夏日心情",
      //     productId: "7121",
      //     memberName: "\"H514R1666679975120\"",
      //     clt: "h5",
      //     userId: "2057695335",
      //     banners: "http://jfopr.haier.com/preview/jfmall/categories/homeDepot/dailyLife/Bedkit/201803/P020180327571295570970.jpg",
      //     skuId: "18348",
      //     thirdProductCode: "3465737456",
      //     token: "86ab1da107b74306aaff6191ca1de0f2",
      //     memberId: "2057695335"
      //   },
      // ]
      let pp1 = [];
      for (let i = 0; i < data.length; i++) {
        if (utils.isNull(data[i].productId) || utils.isNull(data[i].skuId)) {
          let p = {};
          p.amount = data[i].amount;
          p.code = data[i].code;
          p.banners = data[i].banners;
          p.skuId = data[i].skuId;
          p.productId = data[i].productId;
          p.thirdProductCode = data[i].thirdProductCode;
          pp1[i] = p;
          continue;
        }
        let params1 = {
          // id:data[i].productId,
          productId: data[i].productId,
          relationRequests: [
            {
              attValueId: data[i].skuId,
              productParentId: data[i].productId,
            },
          ],
        };
        const res1 = await AndProperty(params1);
        if (res1.code === "0000") {
          let pp = res1.data;
          pp.amount = data[i].amount;
          pp.code = data[i].code;
          pp.banners = pp.mainPictureUrl;
          pp.skuId = data[i].skuId;
          pp.productId = data[i].productId;
          pp.thirdProductCode = data[i].thirdProductCode;
          console.log(pp);
          pp1[i] = pp;
        }
      }
      this.product = pp1;
      console.log(this.product,"this.product")
    },
    //获取数据
    async getProduct() {
      let params = {
        id: this.productId,
      };
      // console.log(this.productId)
      let res = await getProductDetails(params);
      if (res.code === "0000") {
        // this.fruits = res.data;
        // this.banner = res.data.pictureUrl[0].pictureUrl.split(",");
        // this.imgList = res.data.detailUrl.split(",");
        // this.codeList = res.data.code.split(",");
        if (res.data.code == "") {
          this.codeList = ["默认规格"];
        } else {
          this.codeList = res.data.code.split(",");
        }
      }
    },
    detail: function (productId) {
      this.$router.push({
        path: "/productDetails?id=" + productId,
      });
    },
    inverse() {
      this.product.forEach((fruit) => {
        let index = this.model.findIndex((item) => item === fruit.value);
        if (index > -1) {
          this.model.splice(index, 1);
        } else {
          this.model.push(fruit.value);
        }
      });
    },
    // 校验下单数量
    async getByRiskRule() {
      let params = {};
      let res = await getByRiskRule(params);
      if (res.code == "0000") {
        this.num = res.data.frequency;
      }
    },

    async cuts(item, index) {
      let cgv = this.product.filter((it) => it.skuId == item.skuId);

      // this.deleteList.userId = cgv[0].userId;
      // this.deleteList.productId = cgv[0].productId;
      // this.deleteList.skuId = cgv[0].skuId;

      let params = {
        userId:
          this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
        productId: cgv[0].productId,
        amount: -1,
        skuId: cgv[0].skuId,
      };

      const res = await haierOrderShoppingCart(params);
      if (res.code == "0000") {
        this.commCart(res.data);
      }
    },

    async add(item, index) {
      if (this.product[index].amount >= this.product[index].quotaNum) {
        this.$toast(
          "根据商城规定，一个用户一次只能购买" +
            this.product[index].quotaNum +
            "件同种商品~"
        );
        return false;
      }
      let cgv = this.product.filter((it) => it.skuId == item.skuId);

      // this.deleteList.userId = cgv[0].userId;
      // this.deleteList.productId = cgv[0].productId;
      // this.deleteList.skuId = cgv[0].skuId;

      let params = {
        userId:
          this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
        productId: cgv[0].productId,
        amount: 1,
        skuId: cgv[0].skuId,
      };
      const res = await haierOrderShoppingCart(params);
      if (res.code == "0000") {
        this.commCart(res.data);
      }
    },
    orderSettlement: function () {
      if (this.model.length < 1) {
        this.$toast("请先选择商品~");
        return;
      }
      let s = [];
      this.model.forEach((i) => {
        let ss = this.product.filter((it) => it.skuId == i);
        let sss = {};
        sss.productId = ss[0].productId;
        sss.id = ss[0].skuId;
        sss.name = ss[0].chineseName;
        sss.code = ss[0].code;
        sss.point = ss[0].integralNum;
        sss.number = ss[0].amount;
        sss.supplierCode = ss[0].supplierCode;
        sss.supplierName = ss[0].supplierName;
        sss.thirdProductCode = ss[0].thirdProductCode;
        sss.isGivePlus = ss[0].isGivePlus;

        sss.supplierV = ss[0].supplierVCode;
        sss.goodsImgUrl = ss[0].banners;
        s.push(sss);
      });
      this.$router.push({
        path: "/submitOrder",
        query: {
          productList: encodeURIComponent(JSON.stringify(s)),
          crat: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.gopay {
  width: 130px;
  height: 45px;
  line-height: 45px;
  background: $theme-color-main;
  color: white;
  border: 1px $theme-color-main solid;
  border-radius: 20px;
  text-align: center;
}

.settlement {
  padding: 12px 50px;
  background: $theme-color-main;
  color: #fff;
  border-radius: 30px;
  font-size: 28px;
}

.tui-total {
  padding-right: 50px;
}

.tui-flex {
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
}

.item {
  width: 100%;
  display: flex;
  bottom: 0;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  position: fixed;
  font-size: 28px;
}

// .item input[type='checkbox'] {
//     width: 35px;
//     height: 35px;
//     opacity: 0;
//     position: relative;
//     z-index: 2;
// }

// .item span {
//     width: 45px;
//     height: 45px;
//     background: url("../../assets/icon/yuan.png") no-repeat;
//     background-size: 100% 100%;
//     position: absolute;
//     top: 0;
//     left: 0;
//     z-index: 1;
// }

// .item input[type=checkbox]:checked+span {
//     background: url("../../assets/icon/checked.png") no-repeat;
//     background-size: 100% 100%;
// }

.delate {
  display: flex;
  justify-content: flex-end;
  padding-right: 30px;
}

.num {
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  margin: 0 3px;
  background: rgb(239, 239, 239);
}

.add,
.cut {
  font-size: 40px;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: rgb(239, 239, 239);
  border: none;
}

.value {
  max-width: 100%;
  min-width: 120px;
  display: inline-block;
  // height: 35px;
  line-height: 35px;
  padding: 5px 10px;
  background: #f9f9f9;
  border-radius: 20px;
  text-align: center;
  margin-bottom: 30px;
}

.price {
  color: crimson;
  font-size: 30px;
}

.label {
  font-size: 26px;
  padding-bottom: 15px;
}

.tuipopup-item {
  display: flex;
  flex-direction: column;
  // padding: 20px 30px;
  padding: 20px 0 0 30px;
  flex: 1;
}

.fruit {
  display: flex;
  align-items: center;
  padding: 20px 20px;
}

.tui-popup-img {
  margin-left: 20px;
  height: 200px;
  width: 200px;
  border-radius: 24px;
  display: block;
  overflow: hidden;
}

.tuipopup {
  display: flex;
  width: 100%;
}

.tui-checkbox:checked {
  background: $theme-color-main;
  border: solid 1px $theme-color-main;
}

.tui-checkbox {
  width: 36px;
  height: 36px;
  border-radius: 36px;
  background-color: #ffffff;
  border: solid 2px #c9c9c9;
  font-size: 0.8rem;
  outline: none;
  display: inline-block;
  vertical-align: top;
  cursor: default;
  -webkit-appearance: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-transition: background-color ease 0.6s;
  transition: background-color ease 0.6s;
}

.tui-checkbox:checked::after {
  content: "";
  top: 3px;
  left: 1px;
  position: absolute;
  background: transparent;
  border: #fff solid 1px;
  border-top: none;
  border-right: none;
  height: 3px;
  width: 9px;
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
</style>
